import { Box, List } from "@mui/material";
import Usuario from "../../../../../models/usuario";
import { map } from "lodash";
import ItemListaCliente from "./itemListCliente";

type Props = {
  clientes: Usuario[];
};

export default function ListaClientes({ clientes }: Props) {
  return (
    <Box p={1} className="clientes">
      <List
        disablePadding
        sx={{
          width: "100%",
          bgcolor: "background.paper",
          // Painel: radius xl + hairline. Elevação vem do traço, não da sombra.
          borderRadius: 2,
          border: 1,
          borderColor: "divider",
          overflow: "hidden",
          // A última linha não precisa de divider antes da borda do painel.
          "& > li.MuiDivider-root:last-child": { display: "none" },
        }}
      >
        {map(clientes, (cliente) => (
          <ItemListaCliente key={cliente.id} cliente={cliente} />
        ))}
      </List>
    </Box>
  );
}
